export default __webpack_public_path__ + "static/media/sigma-612x612.ff97572f.jpg";